export default __webpack_public_path__ + "static/media/rs_school_js.3d2ae260.svg";